"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddedCoverageField = exports.LimitOptions = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var formik_1 = require("formik");
var get_1 = __importDefault(require("lodash/get"));
var react_1 = __importStar(require("react"));
var control_1 = require("../control");
// eslint-disable-next-line import/no-cycle
var group_1 = require("../group");
var LimitOptions;
(function (LimitOptions) {
    LimitOptions["LIMIT"] = "LIMIT";
    LimitOptions["INCLUDED"] = "INCLUDED";
    LimitOptions["EXCLUDED"] = "EXCLUDED";
    LimitOptions["UNKNOWN"] = "UNKNOWN";
})(LimitOptions = exports.LimitOptions || (exports.LimitOptions = {}));
function EmbeddedCoverageField(_a) {
    var _b, _c, _d, _e;
    var name = _a.name, schema = _a.schema, fieldPath = _a.fieldPath;
    var _f = (0, formik_1.useFormikContext)(), values = _f.values, setFieldValue = _f.setFieldValue, formikErrors = _f.errors;
    var limitsValues = (0, get_1.default)(values, name + "." + fieldPath);
    var errors = (0, get_1.default)(formikErrors, name + "." + fieldPath) || {};
    (0, react_1.useEffect)(function () {
        // if limitsValues is falsy we don't want to set anything
        if ((limitsValues === null || limitsValues === void 0 ? void 0 : limitsValues.type) && (limitsValues === null || limitsValues === void 0 ? void 0 : limitsValues.type) !== LimitOptions.LIMIT) {
            setFieldValue(name + "." + fieldPath, {
                type: limitsValues === null || limitsValues === void 0 ? void 0 : limitsValues.type,
            });
        }
        if (!(limitsValues === null || limitsValues === void 0 ? void 0 : limitsValues.type)) {
            setFieldValue(name + "." + fieldPath, undefined, false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [(limitsValues === null || limitsValues === void 0 ? void 0 : limitsValues.type) || null]);
    var expandable = (limitsValues === null || limitsValues === void 0 ? void 0 : limitsValues.type) === LimitOptions.LIMIT;
    return (react_1.default.createElement("div", { style: {
            width: '100%',
        } },
        react_1.default.createElement("div", { style: { background: '#fff' } },
            react_1.default.createElement(core_ui_1.ExpandableRow, { expanded: expandable, disabled: !expandable },
                react_1.default.createElement(core_ui_1.ExpandableHead, { alignItems: "center", arrowPosition: "left" },
                    react_1.default.createElement("div", { style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        } },
                        react_1.default.createElement(core_ui_1.Text, null, schema.inputMetadata.label),
                        ((_b = schema.properties) === null || _b === void 0 ? void 0 : _b.type) && (react_1.default.createElement(core_ui_1.Field, { fieldId: "type", error: errors.type, style: { minWidth: 170 }, hideEmptyLabel: true },
                            react_1.default.createElement(control_1.SchemaInputControl, { name: name, type: (_c = schema.properties) === null || _c === void 0 ? void 0 : _c.type.inputType, schema: schema, metadata: (_d = schema.properties) === null || _d === void 0 ? void 0 : _d.type.inputMetadata, fieldPath: fieldPath + ".type" }))))),
                react_1.default.createElement(core_ui_1.ExpandableBody, { paddingX: 0 },
                    react_1.default.createElement(core_ui_1.Padding, { top: 16, x: 24, style: {
                            borderTop: "1px solid " + core_ui_1.colors.steel[200],
                        } }, (_e = schema.layout) === null || _e === void 0 ? void 0 : _e.map(function (_a, index) {
                        var inputs = _a.inputs;
                        if (!expandable) {
                            return null;
                        }
                        return (
                        // eslint-disable-next-line react/no-array-index-key
                        react_1.default.createElement("div", { key: index }, inputs.map(function (key, inputIndex) {
                            var _a, _b;
                            var nestedSchema = (0, get_1.default)(schema, "properties." + key);
                            if (!nestedSchema) {
                                return null;
                            }
                            return (react_1.default.createElement("div", { key: key },
                                inputIndex > 1 && (react_1.default.createElement(core_ui_1.Padding, { y: 12 },
                                    react_1.default.createElement(core_ui_1.Divider, null))),
                                react_1.default.createElement(core_ui_1.Flexbox, null,
                                    key === 'limit' && (react_1.default.createElement("div", { style: {
                                            width: 100,
                                            minWidth: 100,
                                        } },
                                        react_1.default.createElement(core_ui_1.Text, { weight: 600, style: {
                                                paddingRight: 16,
                                            } }, (_a = nestedSchema.inputMetadata) === null || _a === void 0 ? void 0 : _a.label))),
                                    react_1.default.createElement(core_ui_1.FlexCell, null,
                                        react_1.default.createElement(core_ui_1.Stack, { gap: 12, direction: "vertical" }, (_b = nestedSchema.layout) === null || _b === void 0 ? void 0 : _b.map(function (group, ind) { return (react_1.default.createElement(group_1.SchemaInputGroup, { gap: 8, key: name + "-SchemaInputGroup-item-identifier-" + (ind + 1), group: group, name: name, schema: nestedSchema, currentPath: fieldPath + "." + key + ".", hideEmptyLabel: true })); }))))));
                        })));
                    }))))),
        react_1.default.createElement("div", { style: { height: 18, background: 'transparent' } })));
}
exports.EmbeddedCoverageField = EmbeddedCoverageField;
